import * as React from 'react';
import type { FundIconPropsType } from './types';

const FundIcon: React.FC<FundIconPropsType> = ( props: FundIconPropsType ) => (
    <img
        src='/static/front/assets/chevron/chevron-xs-up.png'
        className={ `Fund-chevron-img inline-block ${ props.expanded ? 'translate-x-px translate-y-px rotate-0' : '-translate-x-px rotate-90' } ${ props.className || '' }` }
    />
);

export { FundIcon };
